import { gql } from "@apollo/client";

export const GET_CHANGELOG = gql`
  query Changelog($id: ID!, $service: String!, $eventDateBefore: String!, $eventDateAfter: String, $author: String!, $anchor: String!) {
    changelog(id: $id, service: $service, eventDateBefore: $eventDateBefore, eventDateAfter: $eventDateAfter, author: $author, anchor: $anchor) {
      id
      pages {
        anchor
        next
      }
      objects {
        resourceId
        service
        action
        author
        eventDate
        resourceType
        resourceSubType
        notes
        resource
            notes
            resource
      }
    }
  }
`;
